import { useState, useEffect } from "react";
import { Modal, Container, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import ProductCard from "./ProductCard";

export default function FeaturedProducts() {
  const [products, setProducts] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    const apiUrl = process.env.REACT_APP_API_BASE_URL;

    console.log("API URL:", `${apiUrl}/products/active`);

    fetch(`${apiUrl}/products/active`)
      .then((res) => {
        console.log("Response status:", res.status);

        if (!res.ok) {
          throw new Error(`API returned ${res.status}`);
        }

        return res.json();
      })
      .then((data) => {
        console.log("Products received:", data);

        const featuredProducts = [];
        const usedIndices = new Set();

        while (
          featuredProducts.length < 3 &&
          data.length > featuredProducts.length
        ) {
          const randomIndex = Math.floor(Math.random() * data.length);

          if (!usedIndices.has(randomIndex)) {
            usedIndices.add(randomIndex);
            featuredProducts.push(data[randomIndex]);
          }
        }

        setProducts(featuredProducts);
      })
      .catch((error) => {
        console.error("FAILED TO LOAD PRODUCTS:", error);
      });
  }, []);

  const handleShowModal = (product) => {
    setSelectedProduct(product);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setSelectedProduct(null);
    setShowModal(false);
  };

  return (
    <section className="featured-products">
      <Container>
        <div className="featured-heading text-center">
          <span className="section-eyebrow">FROM OUR KITCHEN</span>

          <h2>Our sweet favorites</h2>

          <p>A few of the treats our customers can't resist.</p>
        </div>

        <Row className="g-4 justify-content-center">
          {products.map((product) => (
            <div className="col-12 col-md-6 col-lg-4" key={product._id}>
              <ProductCard
                productProp={product}
                onSelect={() => handleShowModal(product)}
              />
            </div>
          ))}
        </Row>

        <div className="featured-action text-center">
          <Link to="/products" className="featured-view-button">
            View All Desserts
          </Link>
        </div>
      </Container>

      {selectedProduct && (
        <Modal show={showModal} onHide={handleCloseModal} centered>
          <Modal.Header closeButton>
            <Modal.Title>{selectedProduct.name}</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <p>{selectedProduct.description}</p>

            <p>
              <strong>Price:</strong> PhP {selectedProduct.price}
            </p>
          </Modal.Body>

          <Modal.Footer>
            <Link to="/products" className="featured-modal-button">
              Go to Products
            </Link>
          </Modal.Footer>
        </Modal>
      )}
    </section>
  );
}
